import { API_ROOT, API_SECRET } from '../constants/general'

class PlantSitting {

    static post = (url, params) => {

        let data = fetch(API_ROOT + "plantsitting/" + url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id_user: localStorage.getItem('idU'),
                app_token: localStorage.getItem('app_token'),
                ...params
            })
               
        }).then(function (response) {
            return response.json()
        }).then(function (data) {
            
            return data

        })

        return data

    }

}

export default PlantSitting